import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { ContentProvider } from "./lib/content";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import Product from "./pages/Product";
import Checkout from "./pages/Checkout";
import OrderConfirmation from "./pages/OrderConfirmation";
import Guides from "./pages/Guides";
import Visit from "./pages/Visit";
import Admin from "./pages/Admin";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ContentProvider>
          <CartProvider>
          <Header />
          <CartDrawer />
          <main className="min-h-[60vh]">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:id" element={<Product />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order/:id" element={<OrderConfirmation />} />
              <Route path="/guides" element={<Guides />} />
              <Route path="/visit" element={<Visit />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </main>
          <Footer />
          <Toaster
            position="bottom-center"
            toastOptions={{
              style: {
                background: "#FDFBF7",
                color: "#2C1E16",
                border: "1px solid #E8E1D5",
                borderRadius: "0",
                fontFamily: "Manrope, sans-serif",
              },
            }}
          />
        </CartProvider>
        </ContentProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
